module.exports = __webpack_public_path__ + "img/LibertyLearning.73ff742c.jpg";